import { DefaultService } from '@/services/DefaultService';

export default class MotivoNaoVendaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(motivonaovenda) {
        return this._http.post(`${this._env}/sales/nosalesreason`, motivonaovenda, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id) {
        return this._http.get(`${this._env}/sales/nosalesreason/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    
    updateSituacao(motivo){
        return this._http.post(`${this._env}/sales/nosalesreason/updatesituacao`, motivo, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/sales/nosalesreason/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(page = 0, limit = 50,situacao = 2, order = 'asc', column = 'descricao',...params) {
        return this._http.get(encodeURI(`${this._env}/sales/nosalesreason.json?page=${page}&limit=${limit}&situacao=${situacao}&order=${order}&column=${column}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}